import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import T from 'prop-types';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import { Card, CardBody, Form } from 'reactstrap';

export default class TeamShare extends React.Component {
  static propTypes = {
    match: T.object,
    teamShareUrl: T.string,
  };

  static defaultProps = {
    match: undefined,
    teamShareUrl: undefined,
  };

  state = {
    linkCopied: false,
  };

  handleCopy = () => {
    this.setState({ linkCopied: true });
  };

  doNothing = (e) => {
    e.preventDefault();
  };

  render() {
    if (this.props.teamShareUrl.indexOf('/undefined') === -1) {
      return (
        <div>
          <div className="instruction-header">Invite your team members</div>
          <Card>
            <CardBody>
              <div className="col with-padding">
                <Form>
                  <div className="copy-button-container">
                    <InputGroupBlock
                      type="text"
                      labelText="Share the link below with your team members"
                      name="shareLink"
                      autoComplete="off"
                      tabIndex="3"
                      readOnly="readOnly"
                      value={this.props.teamShareUrl}
                      className="share-link-input height-50"
                      inputGroupClassName="share-link-input-group"
                    />
                    <div className="margin-bottom-20">
                      <CopyToClipboard
                        onCopy={this.handleCopy}
                        text={this.props.teamShareUrl}
                      >
                        <Button
                          id="copyBtn"
                          onClick={this.doNothing}
                          className="content-center btn-success copy-button"
                        >
                          {this.state.linkCopied ? 'Copied' : 'Copy'}
                        </Button>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <p className="share-text form-control-label">
                    They will be able to join the team in less than a minute.
                  </p>
                  <Button
                    className="btn-1 btn-full-width success-sm"
                    color="primary"
                    tabIndex="5"
                    onClick={() => history.push(`${this.props.match.url}/account`)}
                  >
                    CONTINUE
                  </Button>
                </Form>
              </div>
            </CardBody>
          </Card>
        </div>
      );
    }
    return null;
  }
}
